import { Component, input, computed } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DocumentGroupVersion } from '../../models/documentGroup';
import moment from 'moment';

@Component({
  selector: 'app-document-version-select',
  templateUrl: './document-version-select.component.html',
  styleUrls: ['./document-version-select.component.scss']
})
export class DocumentVersionSelectComponent {
  versions = input.required<DocumentGroupVersion[]>();
  currentlySelectedVersionNumber = input<number>();
  currentDocumentVersion = input<string>();

  options = computed(() =>
    [...this.versions()].sort((a, b) => b.versionNumber - a.versionNumber)
  );

  constructor (
    private readonly router: Router,
    private readonly translate: TranslateService
  ) {
  }

  navigateTo(version: DocumentGroupVersion) {
    this.router.navigate(['/documents', version.ref]);
  }

  isCurrentlySelectedVersion(version: DocumentGroupVersion) {
    return version.versionNumber === this.currentlySelectedVersionNumber();
  }

  isCurrentDocumentVersion(id: string) {
    return id === this.currentDocumentVersion();
  }

  getLabel(version: DocumentGroupVersion) {
    return version.label ??
      `${this.translate.instant('DOCUMENT.VERSION')} ${version.versionNumber}`;
  }

  getDate(dateStr: string) {
    return moment(dateStr).format('DD/MM/YYYY');
  }
}
